export default "__VITE_ASSET__CAUQarU3__"